import React, { Fragment, useEffect, useState } from "react";
import { Alert, Button, Table, Collapse, Row, Col } from "react-bootstrap";
import RadioGroup from "../radioGroup";
import Radio from "../radio";
import "./course.css";


export const DeatilInfoForm = ({ info }) => {
  return (
    <Fragment>
      <Alert>과목</Alert>
      <Table>
        <thead>
          <tr>
            <th>과목 이름</th>
            <th>교수 이름</th>
            {/* <th>강의실</th>
            <th>수업 시간</th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{info.courseName}</td>
            <td>{info.professorName}</td>
            {/* <td>{info.classRoom}</td>
            <td>{info.classHour}</td> */}
          </tr>
        </tbody>
      </Table>
    </Fragment>
  );
};

export const DetailStudentForm = ({ students }) => {
  let rowStudents = [];
  for (let i = 0; i < students.length; i += 3) {
    rowStudents.push(students.slice(i, i + 3));
  }
  //console.log(rowStudents);

  return (
    <Fragment>
      <Alert closeVariant="">학생</Alert>
      <Table>
        <thead>
          <tr>
            <td>번호</td>
            <td>학번</td>
            <td>이름</td>
            <td>번호</td>
            <td>학번</td>
            <td>이름</td>
            <td>번호</td>
            <td>학번</td>
            <td>이름</td>
          </tr>
        </thead>
        <tbody>
          {rowStudents.map((it, index) => {
            return (
              <tr key={index}>
                {it.map((st, sIndex) => {
                  return (
                    <Fragment key={sIndex}>
                      <td>{index * 3 + 1 + sIndex}</td>
                      <td>{st.number}</td>
                      <td>{st.name}</td>
                    </Fragment>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Fragment>
  );
};

export const DetailQuestForm = ({ quests, professorID, handleSaveQuiz, handleSave7Quiz }) => {
  const [editquiz, setEditQuiz] = useState(-1);
  const [changedQuest, setChangedQuest] = useState(false);

  const onSetEditQuiz = (index) => {
    if( index === -1 ){
      setChangedQuest(false);
    }

    setEditQuiz(index);
  }

  const onQuizInputHandler = (e, quiz) => {
    quiz.ask = e.target.value;
    setChangedQuest(true);
  }

  const onQuizRadioHandler = (e, quiz) => {    
    quiz.answer = e;
    setChangedQuest(true);
  }

  const hadleSave = (e, questID, content) => {
    if( changedQuest ){
      content.professor = professorID;
      console.log( "content : ", content )
      handleSaveQuiz(questID, content);

      setChangedQuest(false);
    }
  } 
  
  const on7QuizAnswerInputHandler = (e, content) => {
    content.answer = e.target.value;    
    setChangedQuest(true);
  }

  const on7QuizInputHandler = (e, index, content) => {    
    content.quiz[index] = e.target.value;       
    setChangedQuest(true);
  }

  const hadle7QuizSave = (e, questID, content) => {
    if( changedQuest ){
      content.professor = professorID;
      console.log( "content : ", content )
      handleSave7Quiz(questID, content);

      setChangedQuest(false);
    }
  }


  const formEdit7Quiz = (quest) => {
    const content = quest.contents[0]; 
    console.log( "quiz : ", content)

    return(
      <tr>
          <th></th> 
          <td colspan ={5}>
          <h4>새로운 문제를 입력하세요.</h4>

          <p>
            <div style={{marginBottom : 10}}>

            정답 : 
            <input className = "answer_box"
              onChange={(e) => on7QuizAnswerInputHandler(e, content)}
              type="text"
              defaultValue = {content.answer}
              maxLength = {250}
            />
            </div>
            
            {              
              content?.quiz.map((q, index) => {
                return(
                  <p>
                    { "제 " + (index+1) + "  고개"}
                    <input className = "name_box"
                      onChange={(e) => on7QuizInputHandler(e, index, content)}
                      type="text"
                      defaultValue = {q}
                      maxLength = {250}/>
                  </p>
                )
              }) 
            }
          </p>
              <Button onClick = { (e) => hadle7QuizSave(e, quest.id, content) } 
                      name="Edit.quest.detail" 
                      value="Edit.quest.detail" 
                      style={{width : 160, marginLeft: 16}}
              > 
                저장 
              </Button>
              <Button onClick = { () => { onSetEditQuiz(-1); }} 
                      name="Edit.quest.close" 
                      value="Edit.quest.close"
                      style={{width : 110, marginLeft: 16}}                     
              >
                닫기 
              </Button>        
        </td>
      </tr>
    )
  }

  const formEditQuiz = (quest) => {
    const content = quest.contents[0]; 
    
    return (
      <tr>
        <th></th>
        <td colspan={5}>
          <h4>새로운 문제를 입력하세요</h4>          
          <div style={{marginBottom: 16, marginTop: 16}}>
            {
              content?.quiz.map((q, index) => 
              { 
                return( 
                  <div > 
                    문제 : 
                    <input className = "name_box" 
                      onChange={(e) => onQuizInputHandler(e, q)} 
                      type="text" 
                      defaultValue = {q.ask} 
                      maxLength = {250}/>     
                    <div style={{marginBottom: 13}}>
                      <RadioGroup>
                      정답 :                          
                      <Radio name= {"answer"+index} 
                        value={false}
                        defaultChecked={!q.answer} 
                        onChange={(e) => onQuizRadioHandler(e, q)}
                      > 
                        틀림 
                      </Radio>
                      <Radio name= {"answer"+index} 
                        value={true}
                        defaultChecked={q.answer}
                        onChange={(e) => onQuizRadioHandler(e, q)}>  
                        맞음 
                      </Radio>                        
                      </RadioGroup>
                    </div>                 
                  </div>
                ) 
              }) 
            }
          </div>
          <div>
            <Button onClick = { (e) => hadleSave(e, quest.id, content) } 
                    name="Edit.quest.detail" 
                    value="Edit.quest.detail" 
                    style={{width: 160, marginLeft: 16}}
            > 
            저장 
            </Button>          
            <Button onClick = { () => { onSetEditQuiz(-1); }} 
                    name="Edit.quest.close" 
                    value="Edit.quest.close" 
                    style={{width: 110, marginLeft: 16}}
            > 
            닫기 
            </Button>        
          </div>        
        </td>
      </tr>
    )
  }

  return (
    <Fragment>
      <Alert>퀘스트(Quest)</Alert>
      <Table>
        <thead>
          <tr>
            <td>고유 번호</td>
            <td>QRCode</td>
            <td>건물 이름</td>
            <td>게임 이름</td>
            <td>건물 위치</td>
            <td>편  집</td>
          </tr>
        </thead>
        <tbody>
          {quests.map((it, index) => {
            return (
              <>
                <tr key={index}>
                  <td>{it.number}</td>
                  <td>{it.qrcode}</td>
                  <td>{it.buildingName}</td>
                  <td>{it.gameName}</td>
                  <td>{it.buildingPosition}</td>
                  <td>{it.gameNumber === "6" || it.gameNumber === "3"
                      ? <Button 
                        onClick={() => { 
                                editquiz === -1 
                                ? onSetEditQuiz(index) 
                                : onSetEditQuiz(-1)}} 
                        name="Edit.quest" 
                        value="Edit.quest" 
                        className="d-flex" > 
                          수정하기 
                        </Button> 
                      : ""} 
                  </td>
                </tr> 
                  {
                    editquiz === index 
                    ? it.gameNumber === "6"
                    ? formEditQuiz(it) 
                    : it.gameNumber === "3"
                    ? formEdit7Quiz(it)
                    : <></>
                    : <></>
                  }
              </>
            );
          })}
        </tbody>
      </Table>
    </Fragment>
  );
};

export const DetailWeekForm = ({ week, handleEidtWeek }) => {
  const [open, setOpen] = useState(true);
  const handleCollapse = () => {
    setOpen(!open);
  };

  // useEffect(() => {
  //   console.log(week);
  // }, []);

  return (
    <Fragment>
      <Alert>{week.name-11}주</Alert>
      <div className="d-flex">
        <div className="d-flex me-auto">
          <div className="row align-items-center ps-1">
            <div>인증코드 : {week.authCode}</div>
          </div>
        </div>
        <Button
          onClick={handleEidtWeek}
          name={week.name}
          value={week.id}
          className="d-flex"
        >
          {week.name-11}주 수정하기
        </Button>
      </div>

      <Collapse in={open}>
        <Table>
          <thead>
            <tr>
              <td>번호</td>
              <td>팀 이름</td>
              <td>팀원들</td>
              <td>건물들</td>
              <td style={{ visibility: "hidden" }}></td>
            </tr>
          </thead>
          <tbody>
            {week.teams.map((it, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{it.name}</td>
                  <td>{it.members}</td>
                  <td>{it.buildings}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Collapse>
    </Fragment>
  );
};
